import React from 'react'
import { Form } from "react-bootstrap"

const FileField = ({fieldClass, labelClass, type, name, value, required, placeholder, handlechange, accept, label, grpmd}) => (
  <Form.Group  controlId={"validation" + name}>
    { label
      ? <Form.Label className={labelClass}>{label}{required ? '*' : ''}</Form.Label>
      : ''
    }
    <div className={fieldClass}>
      <Form.Control
        required={required}
        type={type}
        name={name}
        value={value}
        onChange={handlechange}
        accept={accept}
        id="custom-file"
      />
      <label for="custom-file" className="custom-file-label">{placeholder}</label>
    </div>
  </Form.Group>
);

export default FileField;